import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './views/error/404.component';
import { P500Component } from './views/error/500.component';
import { LoginComponent } from './views/login/login.component';
import { DelovnaComponent } from './views/delovna/delovna.component';

// import { RegisterComponent } from './views/register/register.component';

import { AuthGuard } from './helpers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'subscriberemails',
    pathMatch: 'full',
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'delovna',
    component: DelovnaComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Domov'
    },
    children: [
      {
        path: 'subscriberemails',
        loadChildren: () => import('./views/subscriberemails/subscriberemails.module').then(m => m.SubscriberemailsModule),
        canActivate: [AuthGuard],
        data: {
          title: 'Pošta'
        }
      }
    ]
  },
  { path: '**', component: P404Component }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
